import * as React from "react";
import { List, Datagrid, DateField, TextField, BooleanField, Filter, TextInput, ImageField, useLocale } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { allLanguages } from '../../lib/utils';

const useStyles = makeStyles(
    theme => ({
        image: {
            borderRadius: '5px',
            width: 'auto',
            maxHeight: '40px',
        }
    }));

const CourseFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn resettable />
    </Filter>
);

export const CourseList = (props) => {
    const locale = useLocale();
    const classes = useStyles();
    return (
        <List title="Percursos" {...props} filters={<CourseFilter />} sort={{ field: 'createdAt', order: 'DESC' }}>
            <Datagrid rowClick="edit">
                <ImageField source="image[src]" label="Imagem" classes={classes} />
                <TextField source={`title[${locale}]`} label="Título" />
                {allLanguages.map(language => <BooleanField source={`published[${language.locale}]`} label={<img src={language.flag} alt={language.locale} />} />)}
                <DateField source="createdAt" label="Criado" />
            </Datagrid>
        </List>
    )
};

export default CourseList;